import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  ActionButton, ActionHeader, Background, BulletText, ButtonForm, CancelButton,
  CheckList, ColoHeader, DuelGraphic, Header, HorizontalLine, IconAction,
  Intro, MapComponent, Question, SingleGraphic, SubHeader, Text, TextBox,
  TextGraphic, Video
} from "./TemplateComponents/helpers";
import { decodeToken } from "../../utils";
import { getTemplateMetaData, getUserCampaignData } from "../../redux/store/template/templateActions";
import axios from "axios";
import '../components/TemplateComponents/helpers/style.css'
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { setLoader } from "../../redux/store/loader/loaderAction";

const Container = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageData, setPageData] = useState([]);
  const [bgData, setBgData] = useState({});
  const [navData, setNavData] = useState([]);
  const [responses, setResponses] = useState([]);
  const [checkboxState, setCheckboxState] = useState({});
  const [selectedButton, setSelectedButton] = useState(null);
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  localStorage.setItem("token", token);
  const dataDecode = decodeToken(token);
  const tmData = useSelector((state) => state.templateReducer.tmData);
  const getUserCampData = useSelector((state) => state.templateReducer.getUserCampData);

  useEffect(() => {
    if (tmData && tmData.templateMetaData) {
      const parsedData = JSON.parse(tmData.templateMetaData);
      console.log("PARSE DATA", parsedData);
      setPageData(parsedData[`page${currentPage}`] || []);
    }
  }, [tmData, currentPage]);

  useEffect(() => {
    if (token) {
      const data = decodeToken(token);
      let userGuid = dataDecode.UserId;
      let campaignCode = dataDecode.campCode;
      if (data) {
        dispatch(getTemplateMetaData({ id: data["uid"], campCode: data["campCode"] }));
        dispatch(getUserCampaignData(campaignCode, userGuid));
      }
    }
  }, [dataDecode.UserId, dataDecode.campCode, dispatch, token]);

  useEffect(() => {
    let bgItem = pageData?.find((item) => item?.type === "Background");
    let navItem = pageData?.find((item) => item?.type === "Navigation");
    let bgValue = bgItem?.values?.find((item) => item?.imageData);
    let navValue = navItem?.values?.find((item) => item);
    setBgData(bgValue ? bgValue : {});
    setNavData(navValue ? navValue : {});
  }, [pageData]);

  const handleSave = (actionButtonData, type) => {
    const stateToUse = checkboxState;
    let responseDesc = [];

    const duplicateData = (array, newItem) => {
      return array.some((item) => item.id === newItem.id && item.parentId === newItem.parentId);
    };

    const addUniqueResponses = (sourceArray) => {
      sourceArray.forEach((item) => {
        if (item.result !== null && item.question !== null && !duplicateData(responseDesc, item)) {
          responseDesc.push(item);
        }
      });
    };

    const extractResponsesFromState = (state) => {
      for (const parentId in state) {
        for (const questionId in state[parentId]) {
          const { question, result } = state[parentId][questionId];
          if (result !== null && question !== null) {
            responseDesc.push({ parentId, id: questionId, question, result });
          }
        }
      }
    };

    const filterAndAddActionData = (actionData, type) => {
      if (actionData) {
        if (type === "Checklist") {
          responseDesc = responseDesc.filter((item) => item.id !== actionData.id);
        } else {
          responseDesc = responseDesc.filter((item) => item.parentId !== actionData.parentId);
        }
        responseDesc.push(actionData);
      }
    };

    extractResponsesFromState(stateToUse);
    addUniqueResponses(responses);

    if (getUserCampData && getUserCampData.responseDesc) {
      addUniqueResponses(getUserCampData.responseDesc);
    }

    filterAndAddActionData(actionButtonData, type);

    const payload = {
      userGuid: dataDecode.UserId,
      campaignCode: dataDecode.campCode,
      responseDesc,
    };

    saveAppointment(payload);
  };

  const saveAppointment = async (payload) => {
    let bearerToken = localStorage.getItem("token");
    const config = { headers: { Authorization: `Bearer ${bearerToken}` } };
    let userGuid = dataDecode.UserId;
    let campaignCode = dataDecode.campCode;
    const data = decodeToken(token);
    try {
      dispatch(setLoader(true))
      const res = await axios.post(`${process.env.REACT_APP_ELXO_BASE_URL}/api/ScheduleAppointment/SaveCampaignResponse`, payload, config);
      if (res.status === 200) {
        dispatch(getTemplateMetaData({ id: data["uid"], campCode: data["campCode"] }));
        dispatch(getUserCampaignData(campaignCode, userGuid));
        dispatch(setLoader(false))

      }
    } catch (error) {
      dispatch(setLoader(false))

      console.error("Error booking appointment:", error);
    }
  };

  const handleNext = () => {
    if (currentPage < pageData.length) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handleBack = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const renderComponent = (item) => {
    switch (item.type) {
      case "Action Header":
        return <ActionHeader key={item.id} data={item} />;
      case "Action Button":
        return <ActionButton key={item.id} data={item} handleSave={handleSave} selectedButton={selectedButton} setSelectedButton={setSelectedButton} />;
      case "BulletText":
        return <BulletText key={item.id} data={item} />;
      case "Button":
        return <ButtonForm key={item.id} data={item} />;
      case "Cancel Button":
        return <CancelButton key={item.id} data={item} />;
      case "Checklist":
        return <CheckList key={item.id} data={item} checkboxState={checkboxState} setCheckboxState={setCheckboxState} handleSave={handleSave} />;
      case "Colo Header":
        return <ColoHeader key={item.id} data={item} />;
      case "Duel Graphic":
        return <DuelGraphic key={item.id} data={item} />;
      case "Header":
        return <Header key={item.id} data={item.values} />;
      // case "Navigation":
      //   return <Navigation key={item.id} data={item} handleBack={handleBack} handleNext={handleNext} currentPage={currentPage} />;
      case "Horizontal Line":
        return <HorizontalLine key={item.id} data={item} />;
      case "Icon Action":
        return <IconAction key={item.id} data={item} />;
      case "Intro":
        return <Intro key={item.id} data={item} />;
      case "Map":
        return <MapComponent key={item.id} data={item} />;
      case "Question":
        return <Question key={item.id} data={item} />;
      case "Single Graphic":
        return <SingleGraphic key={item.id} data={item} />;
      case "Sub Header":
        return <SubHeader key={item.id} data={item} />;
      case "Text":
        return <Text key={item.id} data={item} />;
      case "Text Graphic":
        return <TextGraphic key={item.id} data={item} />;
      case "Text Box":
        return <TextBox key={item.id} data={item} responses={responses} setResponses={setResponses} saveAppointment={saveAppointment} handleSave={handleSave} />;
      case "Video":
        return <Video key={item.id} data={item} />;
      default:
        return null;
    }
  };

  return (
    <div className="container-fluid g-0">
      <div className="card card-custom card-help">
        <div className="card-header bg-blue text-white text-center">
          <img alt="logo" className="w-15" src="../../Logo.svg" />
        </div>
        <div
          className="card-body py-3 card-body-h-vh p-0 container-340 d-flex flex-column justify-content-between"
          style={{
            backgroundImage: `url(${bgData?.imageData})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: `${bgData.backgroundWidth ? bgData.backgroundWidth : '100%'} ${bgData.backgroundHeight ? bgData.backgroundHeight : '100%'}`,
            backgroundPosition: `${bgData?.xPosition ? bgData?.xPosition : "center"} ${bgData?.yPosition ? bgData?.yPosition : "center"}`,
            padding: "10px"
          }}
        >
          <div style={{paddingBottom: navData?.direction ? "65px" : "0"}}>
            {pageData.map((dataItem) => renderComponent(dataItem))}
          </div>
          {navData &&
            <div style={{ padding: 10, paddingBottom: 5, paddingTop: 5, marginBottom: 0, background: "#fff", position: "fixed", width: "100%", bottom: 0 }} className="navigation-buttons d-flex justify-content-between align-items-center mt-auto">
              {(navData?.direction === "left" || navData?.direction === "both") ? (
                <div className="common_button_wrapper">
                  <button
                    style={{ color: navData?.arrow, backgroundColor: navData?.bgColor }}
                    className="section_btn"
                    onClick={handleBack}
                    disabled={currentPage === 1}
                  >
                    <NavigateBeforeIcon />
                  </button>
                </div>
              ) :

                <div className="common_button_wrapper invisible-button">
                </div>
              }
              {(navData?.direction === "right" || navData?.direction === "both") ? (
                <div className="common_button_wrapper">
                  <button
                    style={{ color: navData?.arrow, backgroundColor: navData?.bgColor }}
                    className="section_btn"
                    onClick={handleNext}
                  >
                    <NavigateNextIcon />
                  </button>
                </div>
              ) : ""}
            </div>
          }


        </div>
      </div>
    </div>
  );
};

export default Container;
